/** Полный снимок оверлеев Target Attack (HUD, пауза, game over). Обновляется из `tvAppBootstrap`. */
export type TargetAttackUiSnapshot = {
  hudVisible: boolean;
  pauseVisible: boolean;
  gameOverVisible: boolean;
  score: number;
  split: boolean;
  player1Score: number | null;
  player2Score: number | null;
  pauseSplit: boolean;
  pauseScoreSingle: number;
  pauseP1: number | null;
  pauseP2: number | null;
  lives: number | null;
  timeLeftSec: number | null;
  timerUrgent: boolean;
  gameMode: 'CLASSIC' | 'ARCADE' | 'ZEN' | null;
  streak: number;
  comboCount: number | null;
  currentLevel: number | null;
  levelProgress: number | null;
};

const initial: TargetAttackUiSnapshot = {
  hudVisible: false,
  pauseVisible: false,
  gameOverVisible: false,
  score: 0,
  split: false,
  player1Score: null,
  player2Score: null,
  pauseSplit: false,
  pauseScoreSingle: 0,
  pauseP1: null,
  pauseP2: null,
  lives: null,
  timeLeftSec: null,
  timerUrgent: false,
  gameMode: null,
  streak: 0,
  comboCount: null,
  currentLevel: null,
  levelProgress: null,
};

let snapshot: TargetAttackUiSnapshot = { ...initial };
const listeners = new Set<() => void>();

function same(a: TargetAttackUiSnapshot, b: TargetAttackUiSnapshot): boolean {
  return (
    a.hudVisible === b.hudVisible &&
    a.pauseVisible === b.pauseVisible &&
    a.gameOverVisible === b.gameOverVisible &&
    a.score === b.score &&
    a.split === b.split &&
    a.player1Score === b.player1Score &&
    a.player2Score === b.player2Score &&
    a.pauseSplit === b.pauseSplit &&
    a.pauseScoreSingle === b.pauseScoreSingle &&
    a.pauseP1 === b.pauseP1 &&
    a.pauseP2 === b.pauseP2 &&
    a.lives === b.lives &&
    a.timeLeftSec === b.timeLeftSec &&
    a.timerUrgent === b.timerUrgent &&
    a.gameMode === b.gameMode &&
    a.streak === b.streak &&
    a.comboCount === b.comboCount &&
    a.currentLevel === b.currentLevel &&
    a.levelProgress === b.levelProgress
  );
}

export function getTargetAttackUiSnapshot(): TargetAttackUiSnapshot {
  return snapshot;
}

export function subscribeTargetAttackUi(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

export function setTargetAttackUiSnapshot(next: TargetAttackUiSnapshot): void {
  if (same(snapshot, next)) return;
  snapshot = { ...next };
  listeners.forEach((l) => l());
}

export function patchTargetAttackUi(patch: Partial<TargetAttackUiSnapshot>): void {
  setTargetAttackUiSnapshot({ ...snapshot, ...patch });
}

export function resetTargetAttackUi(): void {
  setTargetAttackUiSnapshot({ ...initial });
}
